<template>
  <section
    class="main-container most-sales-home"
    v-if="products && products.length"
  >
    <div id="most-sales-slider" class="most-sales-slider position-relative">
      <BigTitle class="mb-2 mb-sm-4" title="پرفروش ترین ها در آنجل" />

      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide "
            v-for="(product, index) in products"
            :key="index"
          >
            <Product class="w-100" :key="index" :product="product" />
          </div>
        </div>
      </div>
      <div class="text-center">
        <MoreButton to="/products?sort=top_sales" />
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import BigTitle from "@/parts/Front/nicecomponents/shared/BigTitle";
import MoreButton from "./shared/MoreButton.vue";
import Product from "@/parts/Front/components/product/Product";

import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "mostSalesSlider",
  inject: ["mediaQueries"],
  components: {
    MoreButton,
    BSkeletonImg,
    BigTitle,
    Product,
  },

  inject: ["mediaQueries"],

  methods: {
    initMostSales(kill = false) {
      this.initSwiper("most-sales-slider", kill, () => {
        new Swiper("#most-sales-slider .swiper-container", {
          spaceBetween: 30,

          loop: true,
          speed: 1400,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: "#most-sales-slider .swiper-button-next",
            prevEl: "#most-sales-slider .swiper-button-prev",
          },

          breakpoints: {
            300: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            400: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 15,
            },

            1200: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1550: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
          },
        });
      });
    },
    getEnough(array) {
      return [...array].splice(0, Math.min(array.length, this.showCount));
    },
  },
  mounted() {
    this.initMostSales();
  },
  watch: {
    products() {
      this.initMostSales();
    },
  },
  computed: {
    showCount() {
      if (this.mediaQueries.xxxLarge) {
        return 10;
      }
      if (this.mediaQueries.xxLarge) {
        return 9;
      }

      return 9;
    },
    products() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return null;
      } else {
        return this.$store.getters["front/getHomeData"].mostSales;
      }
    },
  },
};
</script>

<style scoped>
.most-sales-home {
  margin-top: 70px;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #e9e9e9;
  transition: all 0.3s;
}

.swiper-button-next {
  right: -20px;
}

.swiper-button-prev {
  left: -20px;
}

.most-sales-home .swiper-button-prev:hover,
.most-sales-home .swiper-button-next:hover {
  background-color: #000;
}

.most-sales-home .swiper-button-prev .bi path {
  stroke-width: 3px;
}

.most-sales-home .swiper-button-prev:hover .bi path,
.most-sales-home .swiper-button-next:hover .bi path {
  fill: #fff;
}

@media screen and (max-width: 639px) {
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .most-sales-home {
    margin-top: 40px;
  }
}
</style>
<style>
.most-sales-home .swiper-wrapper {
  padding: 8px 0;
}

.most-sales-home .swiper-button-prev:after,
.most-sales-home .swiper-container-rtl .swiper-button-next:after,
.most-sales-home .swiper-button-next:after,
.most-sales-home .swiper-container-rtl .swiper-button-prev:after {
  display: none;
}

@media screen and (max-width: 639px) {
}
</style>
